<template>
  <div class="app-drop-edit-modal t-modal" :class="{ open: isOpen }">
    <div v-if="drop" v-down-outside="close" class="content">
      <header>Dropp Info (saved)</header>
      <form class="main" @submit="save">
        <div class="preview">
          <img :src="drop.url" alt="" />
        </div>
        <div class="title">Dropp Name</div>
        <input
          ref="inputName"
          v-model="drop.name"
          type="text"
          class="b-input"
        />
        <div v-if="error.name" class="error-name">* Name is required</div>

        <div class="title">Dropp Type</div>
        <SelectType :key="drop.type" v-model="drop.type" />
        <div class="title">Dropp Tag</div>
        <SelectTag :key="drop.tag.id" v-model="drop.tag" />
        <!-- <input ref="input" v-model="pin.url" type="text" class="b-input" /> -->
        <div class="controls">
          <input
            class="confirm b-btn"
            type="submit"
            value="Save"
            @click="save"
          />
          <div class="rm-btn b-btn" @click="remove">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.001 512.001" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M505.922 476.567L285.355 256 505.92 35.435c8.106-8.105 8.106-21.248 0-29.354-8.105-8.106-21.248-8.106-29.354 0L256.001 226.646 35.434 6.081c-8.105-8.106-21.248-8.106-29.354 0-8.106 8.105-8.106 21.248 0 29.354L226.646 256 6.08 476.567c-8.106 8.106-8.106 21.248 0 29.354 8.105 8.105 21.248 8.106 29.354 0l220.567-220.567 220.567 220.567c8.105 8.105 21.248 8.106 29.354 0s8.106-21.248 0-29.354z"/></svg>
            Delete
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downOutside } from 'app/utils/directives/down-outside';
import { ModalEvents } from 'app/utils/events';
import SelectTag from 'app/components/common/SelectTag.vue';
import SelectType from 'app/components/common/SelectType.vue';

export default {
  name: 'DropEditModal',
  components: {
    SelectTag,
    SelectType,
  },
  directives: {
    downOutside,
  },
  data() {
    return {
      isOpen: false,
      drop: null,

      error: {
        name: false,
      },
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    ModalEvents.addListener('editDrop:open', this.open);
    ModalEvents.addListener('editDrop:close', this.close);
  },
  destroyed() {
    ModalEvents.removeListener('editDrop:open', this.open);
    ModalEvents.removeListener('editDrop:close', this.close);
  },
  methods: {
    validate() {
      let valid = true;
      if (!this.drop.name) {
        this.error.name = true;
        valid = false;
      } else {
        if (!this.drop.name.replace(/\s/gi, '')) {
          this.error.name = true;
          valid = false;
        }
      }
      return valid;
    },
    open(item) {
      this.drop = { ...item };
      this.isOpen = true;
      // setTimeout(() => {
      //   this.$refs.input.focus();
      // }, 100);
    },
    close() {
      this.isOpen = false;
      this.error.name = false;
    },
    remove() {
      this.$store.dispatch('drop/delete', this.drop.id);
      this.close();
    },
    save(e) {
      e.preventDefault();
      if (!this.validate()) {
        return;
      }
      this.$store.dispatch('drop/edit', this.drop);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-drop-edit-modal {
  .error-name {
    font-size: 12px;
    margin-top: 4px;
    margin-bottom: -12px;
    color: rgb(255, 96, 96);
  }
  .content {
    .preview {
      img {
        width: 100%;
        height: auto;
        max-height: 25vh;
        object-fit: contain;
      }
    }

    .rm-btn {
      color: #b9b9b9;
      display: flex;
      margin-left: 10px;
      padding-left: 10px;
      padding-right: 0px;
      svg {
        width: 8px;
        height: auto;
        margin-right: 3px;
        path {
          fill: #b9b9b9;
        }
      }
    }
  }
}
</style>
